export default function OmahaAcceptanceFacilitiesSection() {
  const facilities = [
    {
      name: "Omaha Main Post Office",
      address: "1124 Pacific St, Omaha, NE 68108",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(402) 348-2650",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Passport acceptance services available by appointment. Photo services on-site. Busiest location in Douglas County — book early.",
    },
    {
      name: "Elkhorn Station Post Office",
      address: "20275 Wirt St, Elkhorn, NE 68022",
      hours: "Mon–Fri 9:00 AM – 4:00 PM, Sat 9:00 AM – 12:00 PM",
      phone: "(402) 289-3100",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Convenient for West Omaha and Elkhorn residents. Passport photos available. Call ahead for Saturday availability.",
    },
    {
      name: "Council Bluffs Main Post Office — Iowa",
      address: "515 S Main St, Council Bluffs, IA 51503",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(712) 323-6880",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Serves Council Bluffs and Iowa-side Omaha metro residents. Appointment recommended. Convenient for Offutt AFB families across the river.",
    },
    {
      name: "Bellevue Post Office",
      address: "2603 Victoria Ave, Bellevue, NE 68005",
      hours: "Mon–Fri 9:00 AM – 3:30 PM",
      phone: "(402) 291-1355",
      website: "https://tools.usps.com/rcas.htm",
      notes: "Primary acceptance facility for Sarpy County and Offutt AFB-area residents. Smaller facility — appointments fill quickly.",
    },
  ];

  return (
    <section id="acceptance-facilities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Passport Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where to Submit a New Passport in Omaha
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            First-time applicants — and most applicants who are not eligible for a standard mail-in renewal or a second passport — must apply in person at a passport acceptance clerk, and all locations require an appointment. This is the self-service option, typically chosen by those on a tighter budget who have at least 1–2+ months before travel and don't mind the slower, standard processing times.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
          {facilities.map((f, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#1A365D] text-base"></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm">{f.name}</h3>
                  <p className="text-gray-500 text-xs mt-0.5">{f.address}</p>
                </div>
              </div>
              <div className="space-y-1.5 text-xs text-gray-500 ml-12">
                <p><i className="ri-time-line text-[#F6C344] mr-1"></i>{f.hours}</p>
                <p><i className="ri-phone-line text-[#F6C344] mr-1"></i>{f.phone}</p>
                <p>
                  <i className="ri-global-line text-[#F6C344] mr-1"></i>
                  <a href={f.website} target="_blank" rel="nofollow noopener noreferrer" className="text-[#1A365D] hover:text-[#F6C344] underline transition-colors">
                    Visit website
                  </a>
                </p>
              </div>
              <div className="mt-3 ml-12 bg-white rounded-md p-3 border border-gray-200">
                <p className="text-gray-500 text-xs leading-relaxed">{f.notes}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#1A365D] rounded-lg p-6 flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
            <i className="ri-lightbulb-line text-[#1A365D] text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="text-white font-bold text-base mb-1">How This Works With Fast Passport Center</p>
            <p className="text-white/60 text-sm leading-relaxed">
              If you plan to use a registered courier service to speed up your passport, you must sign up with us <strong className="text-white">before</strong> visiting the acceptance clerk. If you go to the clerk first without a courier arrangement, the clerk will submit your application through the standard postal mail route — and once that happens, we cannot intervene or take over the process. Secure your courier service now, then visit the clerk prepared.
            </p>
          </div>
          <a
            href="https://fastpassportcenter.com/checkout/"
            className="bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap flex-shrink-0"
          >
            Start Now <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}